<script setup lang="ts">
import { ref, watch } from "vue";
import Button from "../../base-components/Button";
import ProductosListado from "./components/ProductosListado.vue";
import ProductosAgregar from "./components/ProductosAgregar.vue";
import ProductosCategoriasAgregar from "../ProductosCategorias/components/ProductosCategoriasAgregar.vue";
import ProductosCategoriasListado from "../ProductosCategorias/components/ProductosCategoriasListado.vue";

type VistaProductos = "productos" | "categorias";

interface Props {
  initialTab?: VistaProductos;
}

const props = defineProps<Props>();

const vista = ref<VistaProductos>(props.initialTab ?? "productos");
const showFormAgregarProductos = ref(false);
const showFormAgregarCategorias = ref(false);

watch(
  () => props.initialTab,
  v => {
    if (!v) return;
    vista.value = v;
    showFormAgregarProductos.value = false;
    showFormAgregarCategorias.value = false;
  }
);
</script>

<template>
  <div class="mt-4">
    <div
      class="inline-flex rounded-full bg-slate-100 p-1 shadow-sm border border-slate-200"
    >
      <button
        type="button"
        class="px-4 py-1.5 text-sm font-medium rounded-full transition-all"
        :class="
          vista === 'productos'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        "
        @click="vista = 'productos'"
      >
        Productos
      </button>
      <button
        type="button"
        class="px-4 py-1.5 text-sm font-medium rounded-full transition-all"
        :class="
          vista === 'categorias'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        "
        @click="vista = 'categorias'"
      >
        Categorías
      </button>
    </div>
  </div>

  <div v-if="vista === 'productos'" class="mt-5">
    <div class="flex flex-wrap items-center gap-2 mb-4">
      <Button
        variant="primary"
        class="mb-2 mr-1"
        @click="showFormAgregarProductos = true"
      >
        Agregar producto
      </Button>
    </div>

    <ProductosAgregar
      v-if="showFormAgregarProductos"
      @cerrar="showFormAgregarProductos = false"
    />
    <ProductosListado />
  </div>

  <div v-else class="mt-5">
    <div class="flex flex-wrap items-center gap-2 mb-4">
      <Button
        variant="primary"
        class="mb-2 mr-1"
        @click="showFormAgregarCategorias = true"
      >
        Agregar categoría
      </Button>
    </div>

    <ProductosCategoriasAgregar
      v-if="showFormAgregarCategorias"
      @cancelar="showFormAgregarCategorias = false"
      @exito="showFormAgregarCategorias = false"
    />

    <ProductosCategoriasListado />
  </div>
</template>
